import React from "react";
import { useCart } from "react-use-cart";
import { useNavigate } from "react-router-dom";

export default function Cart({ onClose }) {
  const {
    isEmpty,
    items,
    updateItemQuantity,
    removeItem,
    cartTotal,
  } = useCart();

  const navigate = useNavigate();

  const handleCheckout = () => {
    if (onClose) onClose();
    navigate('/checkout');
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-CA', { 
      style: 'currency', 
      currency: 'CAD' 
    }).format(amount);
  };

  return (
    <div className="cart-container">
      <div className="cart-header">
        <h3 className="cart-title">Shopping Cart</h3>
        {onClose && (
          <button className="cart-close-button" onClick={onClose}>×</button>
        )}
      </div>
      
      <div className="cart-items-section">
        {isEmpty ? (
          <div className="cart-empty-state">
            <p>Your cart is empty</p>
            <span className="empty-cart-icon">🛒</span>
          </div>
        ) : (
          <div className="cart-items-list">
            {items.map((item) => (
              <div className="cart-item" key={item.id}>
                <div className="cart-item-info">
                  {item.image && (
                    <img src={item.image} alt={item.name} className="cart-item-image" />
                  )}
                  <div className="cart-item-details">
                    <h4 className="cart-item-name">{item.name}</h4>
                    {item.platform && (
                      <p className="cart-item-platform">Platform: {item.platform}</p>
                    )}
                    {item.description && (
                      <p className="cart-item-description">{item.description}</p>
                    )}
                  </div>
                </div>
                <div className="cart-item-actions">
                  <div className="cart-item-price">{formatCurrency(item.price)}</div>
                  {item.quantity && (
                    <div className="cart-item-quantity">
                      <button 
                        className="quantity-btn"
                        onClick={() => updateItemQuantity(item.id, item.quantity - 1)}
                      >
                        -
                      </button>
                      <span className="quantity-value">{item.quantity}</span>
                      <button 
                        className="quantity-btn"
                        onClick={() => updateItemQuantity(item.id, item.quantity + 1)}
                      >
                        +
                      </button>
                    </div>
                  )}
                  <button 
                    className="cart-item-remove"
                    onClick={() => removeItem(item.id)}
                    title="Remove item"
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {!isEmpty && (
        <div className="cart-footer">
          <div className="cart-total">
            <span className="cart-total-label">Total:</span>
            <span className="cart-total-amount">{formatCurrency(cartTotal)}</span>
          </div>
          <button 
            className="cart-checkout-button"
            onClick={handleCheckout}
          >
            Checkout
          </button>
        </div>
      )}
    </div>
  );
}